<form novalidate>
	<div class="was-validated">
		<?-pond.getFieldInput( 'lat', { type: 'hidden' } )?>
		<?-pond.getFieldError( 'lat' )?>
		<?-pond.getFieldInput( 'lng', { type: 'hidden' } )?>
		<?-pond.getFieldError( 'lng' )?>
	</div>

	<? if( !app.is('authenticated') ) { ?>

		<div id="locate-user-info">
			<div class="py-2 px-3 bt">
				<p class="mb-0 text-secondary small">Pour ajouter une mare sans compte utilisateur, vous devez au moins fournir une adresse email ainsi que le code postal de votre domicile.</p>
			</div>
			<div class="p-3 bt">
				<div class="form-group pb-2">
					<?-pond.getFormField('user_email',"Votre adresse email",{type:'email'},{class:'fw-600'})?>
				</div>
				<div class="form-group mb-0">
					<?-pond.getFormField('user_zip',"Votre code postal",{type:'text'},{class:'fw-600'})?>
				</div>
			</div>
			<div class="py-2 px-3 bt">
				<p class="mb-0 small text-secondary text-center">
					<a href="#default/login" class="fw-600 color-green">Se connecter</a>
					<span class="px-2">|</span>
					<a href="#user/register" class="fw-600 color-green">Créer un compte</a>
				</p>
			</div>
			<div class="py-2 px-3 bt">
				<p class="small text-secondary mb-0">Ces informations resterons strictement privées et nous sont utiles pour vous contacter en cas d'une demande de précisions complémentaires sur votre signalement et à des fins statistiques.</p>
			</div>
		</div>

	<? } ?>

	<div id="locate-footer">

		<div class="py-2 px-3 bt">
			<button type="button" data-toggle="modal" data-target="#locate-validate-modal" class="btn btn-green btn-block"><i class="fas fa-fw fa-plus"></i> Ajouter la mare</button>
		</div>

		<div id="locate-validate-modal" class="modal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Attention !</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<p>Vous êtes sur le point d'ajouter un nouvelle mare.<br/><br/>Assurez-vous que la mare ne soit pas déjà présente sur la carte avant de confirmer l'action.</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
						<button id="locate_validate_modal_confirm" type="submit" class="btn btn-green">Confirmer</button>
					</div>
				</div>
			</div>
		</div>

	</div>

</form>
